var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.info, expression: "info" }
      ],
      ref: "dependencyPopupEl",
      staticClass: "gantt-elastic__chart-tasks-dependency-popup",
      style: Object.assign({}, this.styles),
      on: {
        click: function(event) {
          return event.stopPropagation()
        }
      }
    },
    [
      _c("div", {
        staticClass:
          "gantt-elastic__chart-tasks-dependency-popup-arrow-up-block",
        style: Object.assign(
          {},
          _vm.root.style["dependency-popup-arrow-up-block"]
        )
      }),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "gantt-elastic__chart-tasks-dependency-popup-arrow-up-border",
        style: Object.assign(
          {},
          _vm.root.style["dependency-popup-arrow-up-border"]
        )
      }),
      _vm._v(" "),
      _vm.root.state.options.locale.dependencyPopup
        ? _c(
            "div",
            {
              staticClass: "gantt-elastic__chart-tasks-dependency-popup-title",
              style: Object.assign({}, _vm.root.style["dependency-popup-title"])
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.root.state.options.locale.dependencyPopup
                      .workDependency || ""
                  ) +
                  "\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.info && _vm.info.viewData
        ? _c(
            "div",
            {
              staticClass:
                "gantt-elastic__chart-tasks-dependency-popup-info-container",
              style: Object.assign(
                {},
                _vm.root.style["dependency-popup-info-container"]
              )
            },
            _vm._l(_vm.info.viewData, function(viewData, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "gantt-elastic__chart-tasks-dependency-popup-info-row",
                  style: Object.assign(
                    {},
                    _vm.root.style["dependency-popup-info-row"]
                  )
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "gantt-elastic__chart-tasks-dependency-popup-info-title",
                      style: Object.assign(
                        {},
                        _vm.root.style["dependency-popup-info-title"]
                      )
                    },
                    [_vm._v("\n        " + _vm._s(viewData.title) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "gantt-elastic__chart-tasks-dependency-popup-info-value",
                      style: Object.assign(
                        {},
                        _vm.root.style["dependency-popup-info-value"]
                      )
                    },
                    [_vm._v("\n        " + _vm._s(viewData.value) + "\n      ")]
                  )
                ]
              )
            }),
            0
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }